import React, { useState } from 'react';
import BookSearchItem from "../../BookSearchItem";
import styles from './SearchItem.module.css';

const EducationWorkSearchItem = ({ item, onSubmit, bookSections }) => {
  const [formData, setFormData] = useState({
    part: bookSections[0].id,
    bookid: item.bookid
  });

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  };

  return (
    <BookSearchItem item={item}>
      <select
        name="part"
        value={formData.part}
        onChange={onChange}
        className={styles.select}
      >
        {bookSections.map(item => <option key={`bookSectionsOption${item.id}`} value={item.id}>{item.name}</option>)}
      </select>
      <button className="btn" onClick={() => onSubmit(formData)}>Добавить</button>
    </BookSearchItem>
  );
};


export default EducationWorkSearchItem;